<template>
  <div class="content">
    <edit-fare-group-dialog v-if="details" :show="showEdit" @close="showEdit=false" :form-details="editPayload"/>
    <card class="card-user">
      <template slot="header">
        <h4 class="card-title">{{ $t('fareGroup.title') }}</h4>
      </template>
      <div class="author">
        <div class="block block-one"></div>
        <!--        <div class="block block-two"></div>-->
        <div class="block block-three"></div>
        <div class="block block-four"></div>
      </div>
      <div v-loading="loading" v-if="details">
        <table>
          <tr>
            <td>{{ $t('generic.id') }}:</td>
            <td class="pl-2">{{ details.id }}</td>
          </tr>
          <tr>
            <td>{{ $t('fareGroup.data.description') }}:</td>
            <td class="pl-2">{{ details.description }}</td>
          </tr>
          <tr>
            <td>{{ $t('fareGroup.data.details') }}:</td>
            <td class="pl-2">
              <fare-group-additional-details :details="details.details"/>
            </td>
          </tr>
          <tr>
            <td>{{ $t('generic.createdBy') }}:</td>
            <td class="pl-2">{{ details.created_by }}</td>
          </tr>
          <tr>
            <td>{{ $t('generic.updatedBy') }}:</td>
            <td class="pl-2">{{ details.modified_by }}</td>
          </tr>
          <tr>
            <td>{{ $t('generic.created') }}:</td>
            <td class="pl-2">{{ details.created_at | time }}</td>
          </tr>
          <tr>
            <td>{{ $t('generic.updated') }}:</td>
            <td class="pl-2">{{ details.updated_at | time }}</td>
          </tr>
        </table>
        <div class="button-container mt-3">
          <div class="row">
            <div class="col-6" v-if="$auth.can({fare_group: 'update'}, 'permissions')">
              <el-tooltip :content="$t('fareGroup.editBtnTooltip')"
                          effect="light"
                          :open-delay="300"
                          placement="bottom">
                <base-button block type="info" class="btn pr-3 pl-2" @click.native="handleEdit()">
                  <i class="tim-icons icon-pencil pr-2"/>{{$t('fareGroup.editBtnLabel')}}
                </base-button>
              </el-tooltip>
            </div>
            <div class="col-6"  v-if="$auth.can({fare_group: 'delete'}, 'permissions')">
              <el-tooltip :content="$t('fareGroup.deleteBtnTooltip')"
                          effect="light"
                          :open-delay="300"
                          placement="bottom">
                <base-button block type="danger" class="btn pr-3 pl-2" @click.native="handleDelete()">
                  <i class="tim-icons icon-simple-remove pr-2"/> {{$t('fareGroup.deleteBtnLabel')}}
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>
<script>

  import {mapActions, mapState} from "vuex";
  import swal from "sweetalert2";
  import EditFareGroupDialog from "./EditFareGroupDialog";
  import FareGroupAdditionalDetails from "./FareGroupAdditionalDetails";

  export default {
    name: 'fare-group-details',
    components: {
      EditFareGroupDialog,
      FareGroupAdditionalDetails
    },
    data() {
      return {
        showEdit: false,
        editPayload: {},
      }
    },
    computed: {
      ...mapState({
        loading: state => state.fare_group.loading,
        details: state => state.fare_group.data,
        error: state => state.fare_group.error,
      }),
    },
    methods: {
      ...mapActions(['LoadFareGroup', 'DeleteFareGroup']),
      handleEdit() {
        this.editPayload = {
          id: this.details.id,
          description: this.details.description,
          freePtChangeDuration: this.details.details.free_pt_change_duration,
        };
        this.showEdit = true;
      },
      handleDelete() {
        swal({
          title: this.$t('fareGroup.delete.text'),
          text: `'${this.details.id}'`,
          confirmButtonText: this.$t('fareGroup.delete.actionBtnLabel'),
          cancelButtonText: this.$t('fareGroup.delete.cancelBtnLabel'),
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-secondary',
          type: 'question',
          showCancelButton: true
        }).then(result => {
          if (result.value) {
            this.DeleteFareGroup(this.details).then(() => {
              if (this.error == null) {
                this.$notify({
                  type: 'success',
                  message: this.$t('fareGroup.delete.deletedNotification', this.details),
                  icon: 'tim-icons icon-alert-circle-exc'
                })
                this.$router.push({name: 'fare-groups'});
              }
            })
          }
        });
      },
    },
    mounted() {
      this.LoadFareGroup(this.$route.params.id)
    },
  };
</script>
